import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, DocumentScanner } from "@mui/icons-material";
import Wizard from "../../../../ui/components/Wizard";
import VerifyRegistration from "./FirstStep";
import SecondStep from "./SecondStep";
import { useSignUpParams } from "../../api/getSignUpParams";
import { Box, CircularProgress, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "500px",
    backgroundColor: "white",
    color: theme.palette.grey["700"],
    fontWeight: "600",
  },
}));

export default function SignUpWizard() {
  const submitButtonRef = useRef();
  const notistackClasses = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [currentStep, setCurrentStep] = useState(0);
  const [firstStepValues, setFirstStepValues] = useState();

  const navigate = useNavigate();
  const signUpParams = useSignUpParams();

  const handleStepSubmit = () => {
    submitButtonRef.current.click();
  };

  const handleAlreadyRegistered = (data, _var) => {
    enqueueSnackbar(
      <>
        Detectamos um usuário já cadastrado com esse{" "}
        {signUpParams.data.AUTOCADASTRO_CHAVE}.
        {Boolean(signUpParams.data?.AUTOCADASTRO_SENHA_PADRAO) && (
          <>
            <br />A senha padrão é{" "}
            {signUpParams.data?.AUTOCADASTRO_SENHA_PADRAO}
          </>
        )}
        <br />
        Você será redirecionado para página de login.
      </>,
      {
        autoHideDuration: 5000,
        variant: "withTimer",
        preventDuplicate: true,
        className: notistackClasses.root,
        anchorOrigin: { vertical: "top", horizontal: "center" },
        onExited: () => {
          navigate(
            `../login?&username=${btoa(_var[_var.registrationFieldName])}`
          );
        },
      }
    );
  };

  const handleNotRegistered = (values) => {
    setFirstStepValues(values);
    setCurrentStep(1);
  };

  const handleFinishedRegistration = (res, _var) => {
    enqueueSnackbar(
      <>
        Seu cadastro foi realizado com sucesso.
        <br />
        Seu usuário é "{res.object.username}"
        {Boolean(signUpParams.data?.AUTOCADASTRO_SENHA_PADRAO) ? (
          <> e a senha é "{_var.password}" </>
        ) : (
          `.`
        )}
        <br />
        Você será redirecionado para plataforma.
      </>,
      {
        autoHideDuration: 5000,
        variant: "withTimer",
        className: notistackClasses.root,
        preventDuplicate: true,
        anchorOrigin: { vertical: "top", horizontal: "center" },
        onExited: () => {
          navigate(
            `../login?password=${btoa(_var.password || "ABRH")}&username=${btoa(
              res.object.username
            )}`
          );
        },
      }
    );
  };

  return (
    <Stack>
      <Box className="px-4">
        <Wizard
          currentStepIndex={currentStep}
          steps={[
            {
              label: "Verificar registro",
              icon: <Search />,
              onNextStep: handleStepSubmit,
              hidePreviousStepButton: true,
            },
            {
              label: "Finalizar cadastro",
              icon: <DocumentScanner />,
              onNextStep: handleStepSubmit,
              hidePreviousStepButton: true,
            },
          ]}
        />
      </Box>
      {signUpParams.isLoading ? (
        <div className="py-4">
          <CircularProgress sx={{ display: "block", margin: "auto" }} />
        </div>
      ) : (
        <>
          {currentStep === 0 && (
            <VerifyRegistration
              submitButtonRef={currentStep === 0 ? submitButtonRef : null}
              onAlreadyRegistered={handleAlreadyRegistered}
              onNotRegistered={handleNotRegistered}
            />
          )}
          {currentStep === 1 && (
            <SecondStep
              submitButtonRef={currentStep === 1 ? submitButtonRef : null}
              initialValues={firstStepValues}
              onSuccess={handleFinishedRegistration}
            />
          )}
        </>
      )}
    </Stack>
  );
}
